import { useState, useEffect } from "react";
import config from "../../config.ts";
// @ts-ignore
import Cookies from "js-cookie";
import { clearUserIdentification } from "../services/userback/userbackClient";

const useAuth = () => {
  const apiUrl = config.apiUrl;
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | undefined>();
  const [teacherId, setteacherId] = useState(localStorage.getItem("teacherId"));
  const [accessToken, setAccessToken] = useState(
    localStorage.getItem("accessToken")
  );
  const [refreshToken, setRefreshToken] = useState(
    localStorage.getItem("refreshToken")
  );
  // @ts-ignore
  const [refreshTokenExpiry, setRefreshTokenExpiry] = useState(
    parseInt(localStorage.getItem("refreshTokenExpiry") || "0")
  );

  useEffect(() => {
    setIsAuthenticated(localStorage.getItem("authenticated") === "true");
    // Check if tokens are present and not expired
    const teacherIds = localStorage.getItem("teacherId");
    if (accessToken && refreshToken && refreshTokenExpiry && teacherIds) {
      let currenttime = Math.floor(Date.now() / 1000);
      console.log(currenttime);
      if (currenttime < refreshTokenExpiry) {
        setIsAuthenticated(true);
        if (teacherId == null) {
          // Get the first element
          setteacherId(teacherIds[0]);
        }
      } else {
        //handleExpiredToken();
        signOut();
      }
    } else {
      setIsAuthenticated(false);
      setAccessToken(null);
      setRefreshToken(null);
      setteacherId(null);
    }
  }, []);

  const signIn = (
    teacherId: string,
    accessToken: string,
    refreshToken: string,
    refreshTokenExpiry: number
  ) => {
    setIsAuthenticated(true);
    localStorage.setItem("teacherId", teacherId);
    localStorage.setItem("refreshTokenExpiry", refreshTokenExpiry.toString());
    localStorage.setItem("authenticated", "true"); // Ensure authentication state is set
  };

  const signOut = () => {
    setIsAuthenticated(false);
    localStorage.removeItem("teacherId");
    localStorage.removeItem("teacherIds");
    localStorage.removeItem("refreshTokenExpiry");
    localStorage.removeItem("authenticated"); // Clear authentication state
    clearUserIdentification();
  };

  const handleExpiredToken = async () => {
    const currentTime = Math.floor(Date.now() / 1000);
    if (currentTime >= refreshTokenExpiry) {
      // Attempt to refresh the token
      const response = await fetch(apiUrl + "/OAuth/grant-refresh-token", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({
          jwtAccessToken: accessToken,
          refreshToken: refreshToken,
        }),
      });

      if (response.ok) {
        const data = await response.json();

        const {
          accessToken: newAccessToken,
          refreshToken: newRefreshToken,
          expirationMinutes,
        } = data.data;

        // Update tokens and expiration
        localStorage.setItem("accessToken", newAccessToken);
        localStorage.setItem("refreshToken", newRefreshToken);
        const newExpiryTime =
          Math.floor(Date.now() / 1000) + parseInt(expirationMinutes) * 60;
        localStorage.setItem("refreshTokenExpiry", newExpiryTime.toString());

        setAccessToken(newAccessToken);
        setRefreshToken(newRefreshToken);
        setRefreshTokenExpiry(newExpiryTime);
      } else {
        // If refresh token fails, sign out
        signOut();
        window.location.href = "/"; // Redirect to home page
      }
    } else {
      // If not expired, just set authenticated to false
      setIsAuthenticated(false);
      localStorage.removeItem("teacherId");
      localStorage.removeItem("teacherIds");
      localStorage.removeItem("refreshTokenExpiry");
      clearUserIdentification();
      window.location.href = "/"; // Redirect to home page
    }
  };

  return {
    isAuthenticated,
    teacherId,
    accessToken,
    refreshToken,
    signIn,
    signOut,
    handleExpiredToken,
  };
};

export default useAuth;
